export default "__VITE_ASSET__f5e5eefa__"